/* eslint-disable max-len */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/no-unused-class-component-methods */
import React from 'react';
import { withContainer } from 'core/cache';
import PropTypes from 'prop-types';
import createReactClass from 'create-react-class';
import i18n from 'i18next';

import { removeModal } from 'core/notifications';

import { cache as cachePT } from '../propTypes';
import getTreeItemSelectorModalTreeTransform from '../helpers/getTreeItemSelectorModalTreeTransform';
import getFlattenedTreeWithAncestry from '../../nestedRows/helpers/getFlattenedTreeWithAncestry';
import handleToggleExpandItems from '../../nestedRows/helpers/handleToggleExpandItems';
import handleApplyFilters from '../../search/helpers/handleApplyFilters';

import TreeItemSelectorModal from '../components/treeItemSelectorModal';

const TreeItemSelectorModalContainer = createReactClass({
  propTypes: {
    actionText: PropTypes.string.isRequired,
    fetchTree: PropTypes.func.isRequired,
    defaultSelectValue: PropTypes.shape({}),
    treeItemSelectorModalTree: cachePT({ dataType: 'object' }).isRequired,
    treeItemSelectorModalExpandedIds: cachePT({ dataType: 'array' }).isRequired,
    treeItemSelectorModalFlattenedTree: cachePT({ dataType: 'array' }).isRequired,
    treeItemSelectorModalSearchQuery: cachePT({ dataType: 'string' }).isRequired,
    treeItemSelectorModalSearchResults: cachePT({ dataType: 'array' }).isRequired,
    onActionButtonClick: PropTypes.func.isRequired,
    onSearchInputChange: PropTypes.func,
    item: PropTypes.shape({
      id: PropTypes.number,
      hasChildren: PropTypes.bool,
      data: PropTypes.shape({
        name: PropTypes.string,
      }),
    }).isRequired,
    selectOptions: PropTypes.arrayOf(PropTypes.shape({})),
    treeTopName: PropTypes.string,
    getIsTreeTopEnabled: PropTypes.func,
    noSearchResultsText: PropTypes.string,
    searchPlaceholder: PropTypes.string,
  },

  getDefaultProps() {
    return {
      defaultSelectValue: null,
      selectOptions: [],
      treeTopName: '',
      getIsTreeTopEnabled: () => false,
      onSearchInputChange: () => {},
      noSearchResultsText: i18n.t('no-results-found'),
      searchPlaceholder: i18n.t('search'),
    };
  },

  getInitialState() {
    const { defaultSelectValue: selectValue } = this.props;

    return {
      selectValue,
      destination: null,
      isLoading: true,
      tree: [],
    };
  },

  async componentDidMount() {
    this.setState({ tree: await this.props.fetchTree(), isLoading: false });
    this.setTree();
  },

  componentWillUnmount() {
    const { treeItemSelectorModalSearchQuery, treeItemSelectorModalExpandedIds } = this.props;
    treeItemSelectorModalSearchQuery.set('');
    treeItemSelectorModalExpandedIds.set([0]);
  },

  async handleToggleExpand({ id, children }) {
    await handleToggleExpandItems({
      expandedIdsCacheKey: 'treeItemSelectorModalExpandedIds',
      cacheKey: 'treeItemSelectorModalTree',
      itemId: id,
      children,
      shouldPreventCollapse: false,
    });
  },

  async onSearchInputChange(searchValue) {
    const { treeItemSelectorModalSearchQuery } = this.props;
    treeItemSelectorModalSearchQuery.set(searchValue);
    if (this.props.onSearchInputChange) {
      this.setState({ tree: await this.props.onSearchInputChange({ search: searchValue }), isLoading: false });
      this.setTree();
    }
  },

  onClearSearchClick() {
    const { treeItemSelectorModalSearchQuery } = this.props;
    treeItemSelectorModalSearchQuery.set('');
  },

  async onSelectChange(selectValue) {
    if (selectValue.id === this.state.selectValue.id) return;

    this.setState({ isLoading: true, selectValue });
    this.setState({
      tree: await this.props.fetchTree({ organizationId: selectValue.id }),
      isLoading: false,
    });
    this.setTree();
  },

  onItemClick({ item: destination }) {
    const { destination: selectedDestination } = this.state;

    if (selectedDestination?.id === destination.id) {
      this.setState({ destination: null });
      this.setTree();
    } else {
      this.setState({ destination });
      this.setTree({ destination });
    }
  },

  async onActionClick() {
    const { onActionButtonClick, item } = this.props;
    const { destination, selectValue } = this.state;
    const organizationId = selectValue?.id;
    await onActionButtonClick({ item, destination, organizationId });
    removeModal();
  },

  onCancelClick() {
    removeModal();
  },

  setTree({ destination } = {}) {
    const {
      treeItemSelectorModalTree,
      item: source,
      treeTopName,
      getIsTreeTopEnabled,
      treeItemSelectorModalFlattenedTree,
    } = this.props;
    const data = this.state.tree;
    if (!data) return;

    const transformedData = getTreeItemSelectorModalTreeTransform({
      data,
      source,
      destination,
      treeTopName,
      isTreeTopEnabled: getIsTreeTopEnabled(this.state.selectValue?.id),
    });
    treeItemSelectorModalTree.set(transformedData);
    treeItemSelectorModalFlattenedTree.set(getFlattenedTreeWithAncestry({ data }));
  },

  getIsShowingRows() {
    const { treeItemSelectorModalSearchQuery } = this.props;
    return !treeItemSelectorModalSearchQuery.data;
  },

  getIsShowingSearch() {
    const { treeItemSelectorModalSearchQuery } = this.props;
    return !!treeItemSelectorModalSearchQuery.data;
  },

  getIsShowingNoSearchResults() {
    const { treeItemSelectorModalSearchQuery, treeItemSelectorModalSearchResults } = this.props;
    return (
      !!treeItemSelectorModalSearchQuery.data && !treeItemSelectorModalSearchResults.data.length
    );
  },

  getShouldShowSelect() {
    const { selectOptions } = this.props;
    return selectOptions.length > 1;
  },

  render() {
    const {
      actionText,
      selectOptions,
      treeItemSelectorModalTree,
      treeItemSelectorModalSearchQuery,
      treeItemSelectorModalSearchResults,
      noSearchResultsText,
      item: source,
      searchPlaceholder,
    } = this.props;
    const { selectValue, destination } = this.state;

    const isShowingNoSearchResults = this.getIsShowingNoSearchResults();
    const isShowingRows = this.getIsShowingRows();
    const isShowingSearch = this.getIsShowingSearch();
    const shouldShowSelect = this.getShouldShowSelect();

    return (
      <TreeItemSelectorModal
        actionText={actionText}
        destination={destination}
        handleToggleExpand={this.handleToggleExpand}
        isShowingNoSearchResults={isShowingNoSearchResults}
        isShowingRows={isShowingRows}
        isShowingSearch={isShowingSearch}
        isLoading={this.state.isLoading}
        treeItemSelectorModalSearchResults={treeItemSelectorModalSearchResults.data}
        treeItemSelectorModalTree={treeItemSelectorModalTree.data}
        noSearchResultsText={noSearchResultsText}
        onCancelClick={this.onCancelClick}
        onClearSearchClick={this.onClearSearchClick}
        onItemClick={this.onItemClick}
        onActionClick={this.onActionClick}
        onSelectChange={this.onSelectChange}
        onSearchInputChange={this.onSearchInputChange}
        searchPlaceholder={searchPlaceholder}
        searchValue={treeItemSelectorModalSearchQuery.data}
        selectValue={selectValue}
        selectOptions={selectOptions}
        source={source}
        shouldShowSelect={shouldShowSelect}
      />
    );
  },
});

export default withContainer(TreeItemSelectorModalContainer, {
  cache: {
    treeItemSelectorModalTree: { initialData: { items: {} } },
    treeItemSelectorModalExpandedIds: { initialData: [0] },
    treeItemSelectorModalFlattenedTree: { initialData: [] },
    treeItemSelectorModalSearchQuery: { initialData: '' },
    treeItemSelectorModalSearchResults: {
      initialData: [],
      getDependencies: ({ props }) => [props.treeItemSelectorModalFlattenedTree.data.length],
      getParams: ({ props }) => ({
        search: props.treeItemSelectorModalSearchQuery.data,
      }),
      getResolvedData: ({ props }) =>
        handleApplyFilters({
          data: props.treeItemSelectorModalFlattenedTree.data,
          params: { search: props.treeItemSelectorModalSearchQuery.data },
        }),
    },
  },
});
